import React from 'react'
import AllComp from '../components/AllComp'
import PageHead from './PageHead'
import SectionProp from './SectionProp'
import Footer from './Footer'

function AllProperties() {
  return (
    <div>
      <AllComp/>;
      <PageHead/>;
      <SectionProp/>;
      <Footer/>;
    </div>
  )
}

export default AllProperties
